"use client"

import { Flex, Box, Text } from "@chakra-ui/react"
import { neutral, type, radius, elevation } from "../../theme/tokens"

/**
 * The filter-and-action strip that sits at the top of a report.
 *
 * The page title and the supplier/retailer context live in the command bar, so
 * this carries only what is specific to the page: its filters on the left, its
 * actions on the right. Previously each report drew its own title block with
 * its own colour, weight and badge treatment — "Strike Rate" with pill badges,
 * "Ranging Report" with different ones, Sales with nothing at all.
 */
const PageToolbar = ({ description, filters, actions, ...rest }) => {
  if (!description && !filters && !actions) return null

  return (
    <Flex
      align="center"
      gap={3}
      wrap="wrap"
      mb={4}
      px={3}
      py={2.5}
      bg={neutral[0]}
      border="1px solid"
      borderColor={neutral[200]}
      borderRadius={radius.md}
      boxShadow={elevation.raised}
      {...rest}
    >
      {description && (
        <Text fontSize={type.size.small} color={neutral[500]} mr={1}>
          {description}
        </Text>
      )}

      {filters && (
        <Flex align="center" gap={2} wrap="wrap" flexShrink={0}>
          {filters}
        </Flex>
      )}

      <Box flex="1" minW={0} />

      {actions && (
        <Flex align="center" gap={2} flexShrink={0}>
          {actions}
        </Flex>
      )}
    </Flex>
  )
}

export default PageToolbar
